import { useEffect, useState } from 'react';
import { breakdownContent } from '../content/breakdownContent.js';

// Mini inline formatter for the content module's **strong** / *em* markers —
// content is our own trusted module (never remote), no HTML injection path.
function formatMd(md) {
  const parts = [];
  const regex = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;
  let last = 0;
  let match;
  let key = 0;
  while ((match = regex.exec(md)) !== null) {
    if (match.index > last) parts.push(md.slice(last, match.index));
    const token = match[0];
    if (token.startsWith('**')) parts.push(<strong key={key++}>{token.slice(2, -2)}</strong>);
    else parts.push(<em key={key++}>{token.slice(1, -1)}</em>);
    last = match.index + token.length;
  }
  if (last < md.length) parts.push(md.slice(last));
  return parts;
}

function GateItem({ item }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className={`gate-item${expanded ? ' expanded' : ''}`}>
      <button
        type="button"
        className="gate-item-trigger"
        aria-expanded={expanded}
        aria-controls={`gate-detail-${item.index}`}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <span className="gate-index">{item.index}</span>
        <span className="gate-item-title">{item.title}</span>
        <span className="gate-verify">{item.verify}</span>
        <span className="plus">+</span>
      </button>
      <div className="gate-item-detail" id={`gate-detail-${item.index}`}>
        <div className="gate-item-detail-inner">
          <p>{item.body}</p>
        </div>
      </div>
    </div>
  );
}

export function CaseStudyOverlay({ onBrief, onContact }) {
  useEffect(() => {
    const heading = document.querySelector('.doc-title');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  }, []);

  return (
    <div className="doc-view" id="view-case-study">
      <div className="doc-container">
        <a
          href="#/work/solar"
          className="back-link"
          onClick={(event) => {
            event.preventDefault();
            onBrief();
          }}
        >
          ← Case brief
        </a>
        <span className="eyebrow">{breakdownContent.eyebrow}</span>
        <h1 className="doc-title">{breakdownContent.title}</h1>
        <p className="byline">{breakdownContent.byline}</p>
        <article>
          {breakdownContent.blocks.map((block, index) => {
            if (block.type === 'h2') return <h2 key={index}>{block.text}</h2>;
            if (block.type === 'p') return <p key={index}>{formatMd(block.md)}</p>;
            if (block.type === 'decision') {
              return (
                <blockquote className="decision" key={index}>
                  <span className="decision-label">{block.label}</span>
                  {block.paragraphs.map((paragraph, pIndex) => (
                    <p key={pIndex}>{formatMd(paragraph)}</p>
                  ))}
                </blockquote>
              );
            }
            if (block.type === 'gate') {
              return (
                <div className="gate-checklist" key={index}>
                  <div className="gate-head">
                    <span>{block.head}</span>
                    <span className="gate-status">{block.status}</span>
                  </div>
                  {block.items.map((item) => (
                    <GateItem key={item.index} item={item} />
                  ))}
                  <div className="gate-foot">{block.foot}</div>
                </div>
              );
            }
            if (block.type === 'phase') {
              return (
                <div className="artifact-phase" key={index}>
                  <span className="phase-label">{block.label}</span>
                  <p>{block.text}</p>
                </div>
              );
            }
            return null;
          })}
        </article>
        <div className="doc-footer">
          <a
            href="#/work/solar"
            onClick={(event) => {
              event.preventDefault();
              onBrief();
            }}
          >
            ← Case brief
          </a>
          <a
            href="#contact"
            onClick={(event) => {
              event.preventDefault();
              onContact();
            }}
          >
            Get in touch →
          </a>
        </div>
      </div>
    </div>
  );
}
